// Allows letters (including accented/Unicode), spaces, hyphens, and apostrophes.
// Strips digits and other special characters so they cannot be entered into name fields.
export function sanitizeName(value) {
  if (value == null) return ''
  return String(value).replace(/[^\p{L}\s'\u2019-]/gu, '')
}

export function formatTransactionIdMessage(transactionId) {
  if (transactionId == null || transactionId === '') {
    return 'Transaction Id: (unavailable)'
  }
  return `Transaction Id:\n${String(transactionId)}`
}
